import { render, staticRenderFns } from "./ProductItemList.vue?vue&type=template&id=324e7940"
import script from "./ProductItemList.vue?vue&type=script&lang=js"
export * from "./ProductItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports